import { render, staticRenderFns } from "./WorkInstructions.vue?vue&type=template&id=00b3573d&scoped=true"
import script from "./WorkInstructions.vue?vue&type=script&lang=js"
export * from "./WorkInstructions.vue?vue&type=script&lang=js"
import style0 from "./WorkInstructions.vue?vue&type=style&index=0&id=00b3573d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3573d",
  null
  
)

export default component.exports